// src/themes/dark.ts - UNIQUE COLOR VERSION
import { Theme } from "./types";

export const darkTheme: Theme = {
  "background-light": "15 15 20", // #0F0F14
  "background-dark": "10 10 15", // #0A0A0F
  "card-light": "30 30 40", // #1E1E28
  "card-dark": "25 25 35", // #191923
  "input-light": "45 45 55", // #2D2D37
  "input-dark": "40 40 50", // #282832
  "border-light": "60 60 75", // #3C3C4B
  "border-dark": "55 55 70", // #373746
  primary: "139 92 246", // #8B5CF6
  "primary-hover": "124 58 237", // #7C3AED
  text: "248 250 252", // #F8FAFC
  "text-dark": "241 245 249", // #F1F5F9
  "text-secondary": "203 213 225", // #CBD5E1
  "text-secondary-dark": "148 163 184", // #94A3B8
};
